// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "66355b38acf5160951f76593d0c771a3ae274a69/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};